<template>
	<v-container class="py-16">
		<v-card class="overflow-hidden" flat rounded="xl">
			<v-row class="align-stretch justify-space-between">
				<v-col class="pa-16" cols="12" lg="7" xl="6">
					<div class="font-weight-bold mb-6 pt-16 text-h2 text-lg-h1">
						Find your wish job with Jobs Wish!
					</div>

					<div class="mb-16 font-weight-regular text-h5">
						Looking for your dream job? Search for job openings based on your
						preferred role and location with Jobs Wish, the go-to platform for
						finding the perfect career opportunity.
					</div>

					<v-card class="mb-16 pa-3 rounded" color="blue accent-4" flat tile>
						<v-row>
							<v-col cols="12" md="4">
								<v-text-field
									background-color="white"
									clear-icon="mdi-close-circle-outline"
									clearable
									color="blue accent-4"
									hide-details
									filled
									label="Job Title or Role"
									placeholder="Driver"
									solo
									v-model="keyword"
								/>
							</v-col>

							<v-col cols="12" md="4">
								<v-text-field
									background-color="white"
									clear-icon="mdi-close-circle-outline"
									clearable
									color="blue accent-4"
									hide-details
									filled
									label="City, State, or Zip"
									placeholder="Florida"
									solo
									v-model="location"
								/>
							</v-col>

							<v-col cols="12" md="4">
								<v-btn
									class="font-weight-bold"
									color="grey darken-4"
									block
									dark
									elevation="0"
									height="56"
									x-large
									@click="searchButton"
								>
									Find Now
								</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</v-col>

				<v-col class="d-none d-lg-flex pa-0" cols="12" lg="5">
					<v-img
						src="@/assets/landing/avi-richards-Z3ownETsdNQ-unsplash.jpg"
						width="100%"
					/>
				</v-col>
			</v-row>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'Hero',
	data: () => ({
		keyword: null,
		location: null,
	}),
	methods: {
		searchButton() {
			this.$router.push({
				path: '/search',
				query: { q: this.keyword, l: this.location },
			});
		},
	},
};
</script>
